export const primaryProductFacets = [
	"price",
	"custom.delivery_estimate_days",
	"width",
];
